import React, { useState, useEffect } from "react";
import { Menu, X, Phone, MapPin } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { resolveImage } from "../lib/api";
import { Button } from "./ui/button";

const Navbar = () => {
  const { content } = useContent();
  const { company, navLinks } = content;
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#b91c1c] shadow-[0_8px_30px_rgba(185,28,28,0.25)]"
          : "bg-[#b91c1c]/95 backdrop-blur"
      }`}
    >
      <div className="hidden md:block border-b border-white/15">
        <div className="max-w-7xl mx-auto px-6 py-2 flex justify-between items-center text-xs text-white/90">
          <span>Aşı Garantili • Kapıda Ödeme • Hızlı Teslimat</span>
          <div className="flex items-center gap-5">
            <span className="hidden lg:flex items-center gap-1.5 text-white/75">
              <MapPin className="w-3.5 h-3.5" /> {company.address}
            </span>
            <a
              href={`tel:${(company.phone || "").replace(/\s/g, "")}`}
              className="flex items-center gap-1.5 hover:text-white transition-colors font-semibold"
            >
              <Phone className="w-3.5 h-3.5" /> {company.phone}
            </a>
          </div>
        </div>
      </div>

      <nav className={`max-w-7xl mx-auto px-6 flex items-center justify-between transition-all ${scrolled ? "py-2.5" : "py-3"}`}>
        <a href="#home" className="flex items-center group relative">
          <div className={`relative bg-white rounded-2xl flex items-center justify-center shadow-xl ring-1 ring-black/5 transition-all duration-300 overflow-hidden ${scrolled ? "p-1 -mb-3" : "p-1 -mb-6"}`}>
            <img
              src={resolveImage(company.logo)}
              alt="Aktav Yarka - Tavukçuluk Logosu"
              fetchPriority="high"
              decoding="async"
              className={`w-auto object-contain transition-all duration-300 ${scrolled ? "h-16" : "h-24"}`}
            />
          </div>
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {(navLinks || []).map((link) => (
            <li key={link.href}>
              <a href={link.href} className="text-white/90 hover:text-white text-sm font-medium relative after:content-[''] after:absolute after:left-0 after:-bottom-1.5 after:h-[2px] after:w-0 after:bg-white hover:after:w-full after:transition-all">
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:block">
          <Button asChild className="bg-white text-[#b91c1c] hover:bg-white/90 font-semibold shadow-md">
            <a href="#contact">Teklif Al</a>
          </Button>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menü">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      <div className="h-1 bg-gradient-to-r from-[#7f1d1d] via-[#b91c1c] to-[#7f1d1d]" />

      {open && (
        <div className="lg:hidden bg-[#b91c1c] border-t border-white/10">
          <ul className="px-6 py-4 space-y-3">
            {(navLinks || []).map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={() => setOpen(false)} className="block text-white/90 hover:text-white py-2 border-b border-white/10">
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <Button asChild className="w-full bg-white text-[#b91c1c] hover:bg-white/90">
                <a href="#contact" onClick={() => setOpen(false)}>Teklif Al</a>
              </Button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
